import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { PageHeader } from '@/components/ui-kit/PageBits';

export default function Assignments() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/assignments').then(r => setItems(r.data)); }, []);
  return (
    <div className="p-8 max-w-5xl mx-auto">
      <PageHeader title="Mis tareas" subtitle="Actividades pendientes" testId="assignments-header"/>
      {items.length === 0 ? (
        <div className="text-sm text-slate-500 py-12 text-center rounded-2xl border border-dashed">
          No tienes tareas asignadas.
        </div>
      ) : (
        <div className="space-y-3">
          {items.map(a => (
            <div key={a.id} data-testid={`assignment-${a.id}`} className="rounded-2xl bg-white border border-slate-200 p-5 flex items-center justify-between">
              <div>
                <div className="font-display font-bold text-lg">{a.title}</div>
                <div className="text-sm text-slate-500">{a.description || '—'}</div>
              </div>
              <div className="text-right">
                <div className="font-mono text-amber-600 font-bold">+{a.points} pts</div>
                <div className="text-xs text-slate-500 uppercase tracking-widest">{a.type}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
